import classnames from 'classnames/bind'
import { type EmblaCarouselType } from 'embla-carousel'
import { Fragment, useEffect, useState } from 'react'
import { useTranslate } from 'react-polyglot'
import { Nullish, PropsWithClassName } from '~/@types/generic'

import { ArrowLeftIcon, ArrowRightIcon } from '~/components/Icons'

import { GENERAL } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export function EmblaSliderControls({
  className,
  emblaApi,
  length,
}: PropsWithClassName<{
  emblaApi: Nullish<EmblaCarouselType>
  length: number
}>) {
  const t = useTranslate()

  const [isReady, setIsReady] = useState(false)

  const [previousButtonDisabled, setPreviousButtonDisabled] = useState(false)
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false)

  const { scrollPrev, scrollNext, ...rest } = emblaApi ?? {}

  function onSliderChange(slider: EmblaCarouselType) {
    setPreviousButtonDisabled(!slider?.canScrollPrev?.())
    setNextButtonDisabled(!slider?.canScrollNext?.())
  }

  useEffect(() => {
    if (!emblaApi) return
    onSliderChange(emblaApi)
    emblaApi.on('reInit', onSliderChange).on('select', onSliderChange)

    if (!isReady) setIsReady(true)
  }, [emblaApi, onSliderChange])

  if (!length || !isReady) return null

  return (
    <Fragment>
      <button
        data-comp="embla-controls"
        aria-label={t(GENERAL.PREVIOUS_SLIDER_BUTTON)}
        className={cx(className, css.control, css.prev)}
        disabled={previousButtonDisabled}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()

          scrollPrev?.()
        }}>
        <ArrowLeftIcon theme="dark" className={css.icon} />
      </button>
      <button
        aria-label={t(GENERAL.NEXT_SLIDER_BUTTON)}
        data-comp="embla-controls"
        disabled={nextButtonDisabled}
        className={cx(className, css.control, css.next)}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()

          scrollNext?.()
        }}>
        <ArrowRightIcon theme="dark" className={css.icon} />
      </button>
    </Fragment>
  )
}
